module.exports = __webpack_public_path__ + "img/rule-btn1-act.9c506e26.png";